import { gql, TypedDocumentNode } from '@apollo/client';

import { JobBoardDto, QueryGetJobPositionsByEmployerArgs } from '@pflegia/data-access';

import { JOB_POSITION_FOR_CANDIDATE_FRAGMENT } from '../fragments/job-position-for-candidate';

export const GET_JOB_POSITIONS_BY_EMPLOYER: TypedDocumentNode<{ jobPositionsData: JobBoardDto }, QueryGetJobPositionsByEmployerArgs> = gql`
  query GetJobPositionsByEmployer($employerId: UUID!, $page: Int!, $perPage: Int!, $jobPositionId: UUID) {
    jobPositionsData: getJobPositionsByEmployer(employerId: $employerId, page: $page, perPage: $perPage, jobPositionId: $jobPositionId) {
      jobPositions {
        ...JobPositionForCandidate
      }
      total
    }
  }
  ${JOB_POSITION_FOR_CANDIDATE_FRAGMENT}
`;
